$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('product-input-number')) {
    customElements.define(
      'product-input-number',
      class ProductInputNumber extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }

        init() {
          const _this = this;
          const $input = $(this.querySelector('input'));

          // 阻止输入小数点
          $input.on('keydown', function (e) {
            if (e.key === '.' || e.key === ',') {
              e.preventDefault();
            }
          });

          $input.on('input', function () {
            const max = $input.attr('max');
            // 获取当前输入值
            let value = this.value.replace(/[^\d]/g, '');

            // 如果有输入值，则转换为数字
            if (value) {
              value = parseInt(value);
            }

            // 检查最大值
            const maxValue = parseInt(max);
            if (maxValue === 0) {
              value = 1;
            } else if (value > maxValue) {
              value = maxValue;
              // 显示提示信息
              const message = $input.attr('data-message');
              window.litime.showToast('error', message);
            }

            // 更新输入框值
            $input.val(value || '');

            // 触发数量变化事件
            const productMenu = _this.closest('products-select-menu');
            if (productMenu) {
              const event = new CustomEvent('quantityChange', { detail: value || '' });
              productMenu.dispatchEvent(event);
            }
          });
          $input.on('blur', function () {
            if (this.value <= 0) {
              this.value = 1;
              // 手动触发 input 事件以更新数据
              $input.trigger('input');
            }
          });
          const $input_number_minus = $(this.querySelector('.input-number_minus'));
          const $input_number_plus = $(this.querySelector('.input-number_plus'));
          $input_number_minus.on('click', function () {
            if ($input.val() > 1) {
              $input.val(+$input.val() - 1);
              // 找到最近的 products-select-menu 祖先元素
              const productMenu = _this.closest('products-select-menu');
              if (productMenu) {
                const event = new CustomEvent('quantityChange', { detail: $input.val() });
                productMenu.dispatchEvent(event); // 触发事件到 products-select-menu
              }
            }
          });

          $input_number_plus.on('click', function () {
            const max = $input.attr('max');
            if ($input.val() < +max) {
              $input.val(+$input.val() + 1);
              // 找到最近的 products-select-menu 祖先元素
              const productMenu = _this.closest('products-select-menu');
              if (productMenu) {
                const event = new CustomEvent('quantityChange', { detail: $input.val() });
                productMenu.dispatchEvent(event); // 触发事件到 products-select-menu
              }
            } else {
              // 获取data-message
              const message = $input.attr('data-message');

              window.litime.showToast('error', message);
            }
          });
        }
      }
    );
  }
});
